/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Row } from 'react-table';
import _noop from 'lodash/noop';

import { Checkbox } from '../..';

interface Props<D extends object> {
    row: Row<D>;
}

export function CheckboxCell<D extends object>({ row }: Props<D>): JSX.Element {
    const { checked, onChange } = row.getToggleRowSelectedProps();

    return (
        <Checkbox
            color="quinary"
            checked={checked || false}
            onChange={onChange || _noop}
            label=""
            inputId={`row-selection-${row.id}`}
        />
    );
}
